import {createAsyncThunk} from '@reduxjs/toolkit';
import {logout, userinfoRoutine} from '~/entities/user';
import {operationsRequestRoutine} from '~/redux/finances/financesEffects';
import {paymentType} from '~/redux/types/store/PaymentMethods';

type Payload = {
    type: paymentType;
    id: number;
    actionType: 'topup' | 'withdraw';
    currency: string;
};

export const updatePaymentMethod = createAsyncThunk<void, Payload, {dispatch: AppDispatch; extra: AppServices}>(
    'UPDATE_PAYMENT_METHOD',
    async ({type, id, actionType, currency}, {dispatch, extra}) => {
        const dataToStore = {type, id, currency: currency.toUpperCase()};

        if (actionType === 'topup') {
            const {status} = await extra.paymentMethodPost(dataToStore);
            if (status === 401) {
                dispatch(logout());
                return;
            }
        }
        if (actionType === 'withdraw') {
            const {status} = await extra.withdrawMethodPost(dataToStore);
            if (status === 401) {
                dispatch(logout());
                return;
            }
        }
        dispatch(userinfoRoutine.trigger());
        dispatch(operationsRequestRoutine.trigger());
    }
);

export const addNewCard = updatePaymentMethod({id: 0, type: 'card', actionType: 'topup', currency: 'EUR'});
